import styles from './LoginRedirect.module.css';

import React from 'react';
import { commentsLogin, commentsSignUp } from 'lib/analytics';
import Link from 'next/link';

export default function LoginRedirect() {
  if (typeof window === 'undefined') return null;
  const loginHref = `/login/?redirect=${encodeURIComponent(
    window.location.pathname
  )}`;
  const registerHref = `/login/?redirect=${encodeURIComponent(
    window.location.pathname
  )}&tab=register`;
  return (
    <div className={styles.LoginRedirect}>
      <Link href={loginHref}>
        <a
          className={styles.LoginRedirectButton}
          onClick={() => {
            commentsLogin();
            return true;
          }}
        >
          Log in
        </a>
      </Link>{' '}
      or{' '}
      <Link href={registerHref}>
        <a
          className={styles.LoginRedirectSignUpButton}
          onClick={() => {
            commentsSignUp();
            return true;
          }}
        >
          <strong>sign up</strong>
        </a>
      </Link>{' '}
      to comment
    </div>
  );
}
